import Vue from 'vue'
import Vuex from 'vuex'
import state from "./state"
import createPersistedState from "vuex-persistedstate"
import mutations from "./mutations"
import actions from "./actions"
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
        return {
        // 只储存state中的assessmentData
        orderDetailParams: val.orderDetailParams,
      }
   }
})],
  modules:{}
})
